import React  from "react";
import { Button, InputAdornment, TextField } from "@mui/material";
import {AccountCircle,AddBusiness,ContactPhone,EmailOutlined,PinDrop,Store,List} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

import cashilogo from "../../assets/cashidark.png";

export default function DataArrModal({ dataArr, onClose ,openModal}) 
{
    const navigate = useNavigate();
    if (!dataArr) return null;

    const store_image    = dataArr.store_image || cashilogo;
    const owner_name     = dataArr.owner_name || "";
    const email          = dataArr.email || "";
    const contact_mobile = dataArr.contact_mobile || "";
    const storeListArr   = Array.isArray(dataArr.store_list) ? dataArr.store_list : [];

    const storeAddress = [dataArr.area_name,dataArr.city_name,dataArr.state_name,].filter(Boolean).join(", ");
    const loyaltyLink =    "https://play.google.com/store/apps/details?id=com.loyalty.cashi&hl=en_IN";

    const handleManageLoyalty = () => 
    {
        onClose();
        navigate("/loyaltysetting");
    };

    return (
    <div className="modal-overlay">
    <div className="modal-container" style={{ maxWidth: "40%" }}>
        
        {/* CONTENT */}
        <div className="modal-content">
        <div className="row">

            {/* IMAGE */}
            <div className="col-12 text-end mb-3"><img src={store_image} onError={(e) => (e.target.src = cashilogo)} alt="Store"width="60"/></div>

            {/* STORE NAME */}
            <div className="col-12 mb-3 d-flex gap-2 align-items-end">
                <TextField label="Store Name" value={dataArr.store_name || ""} fullWidth variant="standard"
                    InputProps={{readOnly: true,startAdornment: (<InputAdornment position="start"><Store sx={{ color: "#1A73E8" }} /></InputAdornment>),}}/>

                {storeListArr.length > 1 && (
                        <Button onClick={() => openModal('SELLER_STORE', dataArr)} sx={{ background: "linear-gradient(195deg, #c35920ff, #e68610ff)",
                        color: "#fff", px: 2,minWidth: 42,height: 40}}><List /></Button>
                )}

            </div>

            {/* ADDRESS */}
            <div className="col-12 mb-3">
                <TextField label="Store Address" multiline maxRows={2} value={storeAddress} fullWidth variant="standard"
                    InputProps={{readOnly: true,startAdornment: (<InputAdornment position="start"><PinDrop sx={{ color: "#1A73E8" }} /></InputAdornment>),}}/>
            </div>

            {/* OWNER */}
            <div className="col-md-6 mb-3">
                <TextField label="Contact Name" value={owner_name} fullWidth variant="standard"
                    InputProps={{ readOnly: true,startAdornment: (<InputAdornment position="start"><AccountCircle sx={{ color: "#1A73E8" }} /></InputAdornment>),}}/>
            </div>

            {/* MOBILE */}
            <div className="col-md-6 mb-3">
                <TextField label="Contact Number" value={contact_mobile} fullWidth variant="standard"
                    InputProps={{readOnly: true,startAdornment: (<InputAdornment position="start"><ContactPhone sx={{ color: "#1A73E8" }} /></InputAdornment>),}}/>
            </div>

            <div className="col-12 mb-3">
                <TextField label="Email" value={email} fullWidth variant="standard"
                    InputProps={{readOnly: true,startAdornment: (<InputAdornment position="start"><EmailOutlined sx={{ color: "#1A73E8" }} /></InputAdornment>),}}/>
            </div>

            {/* BUTTONS */}
            <div className="col-12 d-flex justify-content-center gap-3 mt-3">
                
                <Button onClick={onClose} sx={{background:"linear-gradient(195deg, #42424a, #191919)",color: "#fff",px: 4,}}>Close</Button>

                <Button component="a" href={loyaltyLink}target="_blank" 
                    sx={{background:"linear-gradient(195deg, #49a3f1, #1A73E8)",color: "#fff",}}><AddBusiness /> Manage Store</Button>
                
                <Button onClick={handleManageLoyalty} 
                    sx={{background:"linear-gradient(195deg, #c35920ff, #e68610ff)",color: "#fff",px: 2,}}>Manage Loyalty</Button>

                <Button onClick={() => openModal('API_DOC',dataArr)} 
                    sx={{background:"linear-gradient(195deg, #c35920ff, #e68610ff)",color: "#fff",px: 2,}}>API Doc</Button>

            </div>



          </div>
        </div>
      </div>
    </div>
  );
}
